import { formatRupiah } from "@/helpers/utils";
import ApiService from '@/services/api';
import Swal from "sweetalert2";
import { _ } from "gridjs-react";
import dayjs from "dayjs";
import React from "react";

const getStatusBadge = (status) => {
  const badges = {
    process: 'bg-yellow-100 text-yellow-800 border-yellow-300',
    completed: 'bg-green-100 text-green-800 border-green-300',
    cancelled: 'bg-red-100 text-red-800 border-red-300',
    pending: 'bg-gray-100 text-gray-800 border-gray-300'
  };
  return badges[status] || 'bg-gray-100 text-gray-800 border-gray-300';
};

const getStatusText = (status) => {
  const statusText = {
    process: 'Proses',
    completed: 'Selesai',
    cancelled: 'Dibatalkan',
    pending: 'Menunggu'
  };
  return statusText[status] || status;
};

export const tableColumnsMember = [
  { title: 'Member', queryKey: 'full_name' },
  { 
    title: 'Registration Date', 
    queryKey: 'join_date',
    component: (item) => (
      <span>
        {item.join_date ? new Date(item.join_date).toLocaleDateString() : 'N/A'}
      </span>
    ),
  },
  { title: 'Contact', queryKey: 'phone_number' },
  { title: 'Status', queryKey: 'status' },
];

export const columnsHistory = [
  {
    title: 'Tanggal Setor',
    queryKey: 'transaction_date',
    component: (item) => (
      <span>
        {item.transaction_date ? new Date(item.transaction_date).toLocaleDateString() : 'N/A'}
      </span>
    ),
  },
  { 
    title: 'Kode Transaksi', queryKey: 'transaction_number'
  },
  {
    title: 'Detail Pembayaran',
    queryKey: 'bank_account_name',
    component: (item) => (
      <span>
        {item.payment_details.bank_name} - {item.payment_details.bank_account_name} ({item.payment_details.bank_account_number})
      </span>
    )
  },
  {
    title: 'Jumlah',
    queryKey: 'amount',
    component: (item) => (
      <span>
        {formatRupiah(item.amount)}
      </span>
    )
  },
  {
    title: 'Status',
    queryKey: 'status',
    component: (item) => (
      <span className={`text-gray-900 px-3 py-1 text-sm font-semibold rounded-md border ${getStatusBadge(item.status)}`}>
        {getStatusText(item.status)}
      </span>
    )
  },
];

export const actionHistory = (row, fetchHistorySavings, onOpenDetailModal) => {
  const handleApproveClick = (e) => {
    e.preventDefault();
    e.stopPropagation();
    // Open detail modal for approve action with transaction ID
    onOpenDetailModal(row.id);
  };

  const handleCancelClick = async (e) => {
    e.preventDefault();
    e.stopPropagation();
    const result = await Swal.fire({
      title: 'Konfirmasi Cancel',
      text: 'Apakah Anda yakin ingin membatalkan transaksi ini?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#d33',
      cancelButtonColor: '#6c757d',
      confirmButtonText: 'Ya, Batalkan!',
      cancelButtonText: 'Tidak'
    });

    if (result.isConfirmed) {
      try {
        const response = await ApiService.approvalTransaction(row.id, 'cancel');
        if (response.status === 200) {
          Swal.fire({
            icon: 'success',
            title: 'Sukses!',
            text: 'Transaksi berhasil dibatalkan!',
          }).then(() => {
            fetchHistorySavings();
          });
        }
      } catch (error) {
        Swal.fire({
          icon: 'error',
          title: 'Error!',
          text: error.response?.data?.message || 'Gagal membatalkan transaksi',
        });
      }
    }
  };

  return _(
    <>
      {(row.status !== "completed" && row.status !== "cancelled") && (
        <div className="flex gap-3">
          <button
            className='rounded-md bg-green-400 hover:bg-green-500 text-white py-1 p-2 tooltip'
            onClick={handleApproveClick}
            title="Approve & Mapping COA"
          >
            <i className='mgc_check_line'></i>
          </button>
          <button
            className='rounded-md bg-red-400 hover:bg-red-500 text-white py-1 p-2 tooltip'
            onClick={handleCancelClick}
            title="Tolak/Cancel Transaksi"
          >
            <i className='mgc_close_line'></i>
          </button>
        </div>
      )}
    </>
  )
}

export const historyColumns = (fetchHistorySavings, onOpenDetailModal) => [
  {
    name: 'Tanggal Transaksi',
    data: (row) => row.transaction_date,
    formatter: (row) => {
      return _(
        <span>
          {dayjs(row.transaction_date).format('DD/MM/YYYY') || 'N/A'}
        </span>
      )
    }
  },
  {
    name: 'Nomor Transaksi',
    data: (row) => row.transaction_number
  },
  {
    name: 'Keterangan',
    data: (row) => row.id,
    formatter: (cell) => {
      return _(
        <span>
          Pembayaran Simpanan Pokok
        </span>
      )
    }
  },
  {
    name: 'Jumlah',
    data: (row) => formatRupiah(row.amount), 
  },
  {
    name: 'Status',
    data: (row) => row.status,
    formatter: (cell) => {
      const badgeClass = getStatusBadge(cell);
      return _(<span className={`text-gray-900 px-3 py-1 text-sm font-semibold rounded-md border ${getStatusBadge(cell)}`}>{getStatusText(cell)}</span>);
    }
  },
  {
    name: 'Info',
    data: (row) => row,
    formatter: (row) => actionHistory(row, fetchHistorySavings, onOpenDetailModal)
  }
]

export const renderActionMember = (row, onClose, navigate) => {
  const handleClick = () => {
    navigate(`/admin/deposit-principal-savings?id=${row.id}`);
    onClose();
  };
  return (
    <button
      className='rounded-md bg-green-400 hover:bg-green-500 text-white py-1 p-2'
      onClick={handleClick}
    >
      <i className='mgc_check_line'></i>
    </button>
  )
}
